import React, { useRef, useEffect } from 'react';
import { YhBox } from '@/components/YhBox';
import { YhForm } from '@/components/YhFormBox';
import { IYhForm, IYhFormRef, FormItemTypeEnum } from '@/components/YhFormBox/Types';
import { IBasicDetail } from '../basicTypes';
import { Button } from 'antd';
import { basicModel } from '../basicModel';

export function Basic() {
  const formRef = useRef<IYhFormRef>();
  const { fromVal, getFormval, update } = basicModel();
  useEffect(() => {
    getFormval()
  }, [])
  const formConfig: IYhForm<IBasicDetail> = {
    formRef,
    labelCol: { span: 3 },
    formValues: fromVal,
    items: [
      {
        type: FormItemTypeEnum.Input,
        span: 24,
        fieldLabel: "网站名称",
        fieldName: "siteName",
      },
      {
        type: FormItemTypeEnum.Input,
        span: 24,
        fieldLabel: "关键词",
        fieldName: "keywords",
      },
      {
        type: FormItemTypeEnum.Input,
        span: 24,
        fieldLabel: "描述",
        fieldName: "desc",
      },
      {
        type: FormItemTypeEnum.Input,
        span: 24,
        fieldLabel: "关闭原因",
        fieldName: "reason",
      },
      {
        type: FormItemTypeEnum.Switch,
        span: 24,
        fieldLabel: "网站开关",
        fieldName: "status",
      },
      {
        type: FormItemTypeEnum.Input,
        span: 24,
        fieldLabel: "修改id",
        fieldName: "id",
        hidden: true
      },
    ]
  }
  const onAdd = () => {
    formRef.current?.validateFields().then(async res => {
      await update(res)
    })
  }
  return (
    <YhBox title="基础信息/基本信息" style={{ margin: "50px 100px", padding: "50px" }}>
      <YhForm {...formConfig} />
      <Button
        style={{ marginLeft: "200px" }}
        type="link"
        shape="round"
        onClick={() => onAdd()}
      >修改</Button>
    </YhBox>
  );
}


